import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { LoadingComponent } from '@gains-com/ui-angular';

@Component({
  selector: 'app-image-loader',
  standalone: true,
  imports: [LoadingComponent],
  template: `
    <div class="image-loader-container">
      @if (isLoading()) {
        <div class="spinner-overlay">
          <ac-loading [size]="spinnerSize()" />
        </div>
      }
      <img
        [src]="src()"
        [alt]="alt()"
        [class.loaded]="!isLoading()"
        (load)="onImageLoad()"
        (error)="onImageError()"
      />
    </div>
  `,
  styleUrl: './image-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageLoaderComponent {
  src = input.required<string>();
  alt = input<string>('');
  spinnerSize = input<number>(32);

  isLoading = signal(true);

  onImageLoad() {
    this.isLoading.set(false);
  }

  onImageError() {
    this.isLoading.set(false);
  }
}
